import React, { useState,useEffect } from "react";
import '../../components/Registration/Registration.css';
import { useNavigate } from 'react-router-dom';
import { MdOutlineLock } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TiTick } from "react-icons/ti";
import { registerUser, verifyGst } from "../../API/Api";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import RegisterModal from "../RegisterModal";
import { getUserData } from "../../utils/auth";

const Registration = () => {
  const [userType, setUserType] = useState("buyer");
  const [selectedDate, setSelectedDate] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    panCard: "",
    organizationName: "",
    gstTreatment: "",
    gstin: "",
    incorporationDate: "",
    password: "",
    confirmPassword: "",
    address: "",
    pincode: "",
  });
  console.log("MMDDDD:___",formData)
  const [disabledFields, setDisabledFields] = useState({
    organizationName: false,
    gstTreatment: false,
    panCard: false,
    incorporationDate: false
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [passwordStrength, setPasswordStrength] = useState({
    length: false,
    lowercase: false,
    uppercase: false,
    number: false,
  });
  const [gstVerifying, setGstVerifying] = useState(false);
  const [gstVerified, setGstVerified] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const validateForm = () => {
    let valid = true;
    let newErrors = {};

    if (!/^[A-Za-z\s]+$/.test(formData.fullName.trim())) {
      newErrors.fullName = "Enter a valid name (letters only)";
      valid = false;
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(formData.email)) {
      newErrors.email = "Enter a valid email (e.g., user@example.com)";
      valid = false;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
      valid = false;
    }

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.panCard)) {
      newErrors.panCard = "Enter a valid PAN (e.g., ABCDE1234F)";
      valid = false;
    }

    if (formData.organizationName.trim() === "") {
      newErrors.organizationName = "Organization Name is required";
      valid = false;
    }

    if (!formData.gstTreatment) {
      newErrors.gstTreatment = "Select Gst Treatment Type";
      valid = false;
    }

    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
    if (!gstRegex.test(formData.gstin)) {
      newErrors.gstin = "Enter a valid GSTIN";
      valid = false;
    }

    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@!#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~-]{6,15}$/;
    if (!passwordPattern.test(formData.password)) {
      newErrors.password = "Password must be 6-15 chars, include 1 uppercase, 1 lowercase, and 1 number";
      valid = false;
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      valid = false;
    } else {
      newErrors.confirmPassword = "";
    }

    setErrors(newErrors);
    return valid;
  };
  const handleVerifyGst = async () => {
    const gstValidation = validateGST(formData.gstin);
  
    if (!gstValidation.valid) {
      setErrors({ ...errors, gstin: gstValidation.message });
      return;
    }
  
    setGstVerifying(true);
  
    try {
      const response = await verifyGst(formData.gstin);
      if (response) {
        if (response.status === true) {
          if (response.data?.message) {
            toast.success(response.data.message);
          }
  
          const gstin = response.data.data.gstin;
          const panFromGst = gstin.slice(2, 12);
          const address = response.data.data.pradr?.adr || "";
          const pincode = response.data.data.pradr?.addr?.pncd || "";
  
          setFormData(prev => ({
            ...prev,
            organizationName: response.data.data.tradeNam || "",
            gstTreatment: response.data.data.dty.toLowerCase() || "",
            panCard: panFromGst || "",
            incorporationDate: response.data.data.rgdt ?
              new Date(
                response.data.data.rgdt.split('/').reverse().join('-')
              ).toISOString().split('T')[0] : "",
            address: address, // Set address from GST response
            pincode: pincode, // Set pincode from GST response
          }));
  
          setDisabledFields({
            organizationName: true,
            gstTreatment: true,
            panCard: true,
            incorporationDate: true,
          });
  
          setGstVerified(true);
        } else {
          if (response.data?.message) {
            toast.error(response.data.message);
            setErrors({ ...errors, gstin: response.data.message });
          }
          setGstVerified(false);
        }
      }
    } catch (error) {
      console.error('Verification Error:', error);
      setGstVerified(false);
      const errorMessage = error.response?.data?.message || error.message;
      if (errorMessage) {
        toast.error(errorMessage);
      }
    } finally {
      setGstVerifying(false);
    }
  };

  useEffect(() => {
    const userData = getUserData();
    if (userData) {
      setFormData((prevData) => ({
        ...prevData,
        address: userData.address || "",
        pincode: userData.pincode || ""
      }));
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formDataWithUserType = {
      ...formData,
      userType: userType
    };

    if (!validateForm()) {
      return;
    }

    if (!gstVerified) {
      toast.error("Please verify your GST first before registering.");
      return;
    }

    try {
      const response = await registerUser(formDataWithUserType);

      if (response.status === true) {
        toast.success("OTP sent successfully!");
        setRegistrationSuccess(true);
        setShowRegisterModal(true);
      } else {
        toast.error(response.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(error.response?.data?.message || "Email is already registered");
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });

    if (id === "password" || id === "confirmPassword") {
      if (id === "password") {
        const updatedStrength = {
          length: value.length >= 6 && value.length <= 15,
          lowercase: /[a-z]/.test(value),
          uppercase: /[A-Z]/.test(value),
          number: /[0-9]/.test(value),
        };
        setPasswordStrength(updatedStrength);
      }

      // Check password match
      setErrors(prevErrors => ({
        ...prevErrors,
        confirmPassword:
          id === "confirmPassword" || formData.confirmPassword // Ensure both fields are set
            ? value !== formData.password && id === "confirmPassword"
              ? "Passwords do not match"
              : formData.password === value && formData.confirmPassword
                ? "Password Matched"
                : prevErrors.confirmPassword
            : "",
      }));
    }
  };


  const handleUserTypeChange = (e) => {
    setUserType(e.target.value);
  };

  const validateGST = (gstNumber) => {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

    if (!gstNumber) {
      return { valid: false, message: "GST number is required." };
    }

    if (!gstRegex.test(gstNumber)) {
      return { valid: false, message: "Invalid GST number format." };
    }

    return { valid: true, message: "Valid GST number." };
  };

  const handleGstChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, gstin: value });
    setGstVerified(false);

    const gstValidation = validateGST(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      gstin: gstValidation.valid ? "" : gstValidation.message
    }));
  };

  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: "Enter a valid 10-digit phone number",
      }));
      return false;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: "",
      }));
      return true;
    }
  };

  return (
    <div className="registration custom-container-side custom-inner-space">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover

      />
      <h2 className="registration-text">Registration</h2>
      <h3 className="account-text">User Type</h3>
      <div className="user-type">
        <label>
          <input
            type="radio"
            name="userType"
            value="buyer"
            checked={userType === "buyer"}
            onChange={handleUserTypeChange}
            required
          />
          Buyer
        </label>
        <label>
          <input
            type="radio"
            name="userType"
            value="seller"
            checked={userType === "seller"}
            onChange={handleUserTypeChange}
            required
          />
          Seller
        </label>
      </div>

      <form className="registration-form" onSubmit={handleSubmit}>
        <div className="account-information">
          <div className="form-row">
            <h3 className="account-text">Account Information</h3>
            <input type="hidden" name="address" value={formData.address} />
            <input type="hidden" name="pincode" value={formData.pincode} />

            <div className="two-rows">
              <div className="row">
                <div className="form-group">
                  <label htmlFor="fullName">
                    Full Name
                    <span className={`required ${formData.fullName ? "valid" : ""}`}>*</span>
                  </label>
                  <input
                    id="fullName"
                    type="text"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    maxLength={40}
                  />
                  {errors.fullName && <span className="error validtext required">{errors.fullName}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="email">
                    Email Address
                    <span className={`required ${formData.email ? "valid" : ""}`}>*</span>
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <span className="error validtext required">{errors.email}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="phone">
                    Phone Number
                    <span className={`required ${formData.phone ? "valid" : ""}`}>*</span>
                  </label>
                  <input
                    id="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                    maxLength="10"
                    pattern="\d{10}"
                    title="Enter a valid 10-digit phone number"
                    required
                    onBlur={() => validatePhoneNumber(formData.phone)}
                  />
                  {errors.phone && <span className="error validtext required">{errors.phone}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="panCard">
                    PAN CARD
                    <span className={`required ${formData.panCard ? "valid" : ""}`}>*</span>
                  </label>
                  <input
                    id="panCard"
                    type="text"
                    placeholder="e.g. ABCDE1234F"
                    value={formData.panCard}
                    onChange={handleChange}
                    required
                    maxLength={10}
                    disabled={disabledFields.panCard}
                    className={disabledFields.panCard ? "disabled-field" : ""}
                  />
                  {errors.panCard && <span className="error validtext required">{errors.panCard}</span>}
                </div>
              </div>
              <div className="row">
                <div className="form-group gstin-group">
                  <label htmlFor="gstin">
                    GSTIN
                    <span className={`required ${formData.gstin ? "valid" : ""}`}>*</span>
                    {gstVerified && <span className="verified-badge">Verified</span>}
                  </label>
                  <div className="input-with-verify">
                    <input
                      id="gstin"
                      type="text"
                      placeholder="e.g. 27AAAPA1234A1Z5"
                      value={formData.gstin}
                      onChange={handleGstChange}
                      required
                      maxLength={15}
                      className={gstVerified ? "verified" : ""}
                    />
                    <button
                      type="button"
                      className="verify-button"
                      onClick={handleVerifyGst}
                      disabled={gstVerifying || !formData.gstin || errors.gstin}
                    >
                      {gstVerifying ? "Verifying..." : "Verify"}
                    </button>
                  </div>
                  {errors.gstin && <span className="error validtext required  ">{errors.gstin}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="organizationName">
                    Organization Name
                    <span className={`required ${formData.organizationName ? "valid" : ""}`}>*</span>
                  </label>
                  <input
                    id="organizationName"
                    type="text"
                    value={formData.organizationName}
                    onChange={handleChange}
                    required
                    maxLength={10}
                    disabled={disabledFields.organizationName}
                  />
                  {errors.organizationName && <span className="error validtext required">{errors.organizationName}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="gstTreatment">
                    Select GST Treatment:
                    <span className={`required ${formData.gstTreatment ? "valid" : ""}`}>*</span>
                  </label>
                  <select
                    id="gstTreatment"
                    value={formData.gstTreatment}
                    onChange={handleChange}
                    required
                    disabled={disabledFields.gstTreatment}
                  >
                    <option value="" disabled >Select GST Treatment</option>
                    <option value="Regular">Regular</option>
                    <option value="Composition">Composition</option>
                    <option value="Sez">SEZ (Special Economic Zone)</option>
                    <option value="Exempted">Exempted</option>
                    <option value="Nongst">Non-GST</option>
                    <option value="Unregistered">Unregistered</option>
                    <option value="Overseas">Overseas</option>
                  </select>
                  {errors.gstTreatment && <span className="error validtext required">{errors.gstTreatment}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="incorporationDate">
                    GST Registration Date
                    <span className={`required ${formData.incorporationDate ? "valid" : ""}`}>*</span>
                  </label>
                  <DatePicker
                    id="incorporationDate"
                    selected={formData.incorporationDate ? new Date(formData.incorporationDate) : null}
                    onChange={(date) => setFormData({
                      ...formData,
                      incorporationDate: date.toISOString().split('T')[0]
                    })}
                    className="my-custom-datepicker"
                    dateFormat="dd/MM/yyyy"
                    maxDate={new Date()}
                    required
                    placeholderText="DD/MM/YYYY"
                    disabled={disabledFields.incorporationDate}
                    readOnly={disabledFields.incorporationDate}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                  {errors.incorporationDate && <span className="error validtext required">{errors.incorporationDate}</span>}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <h3 className="account-text">Access credentials</h3>

          <div className="form-group">
            <label htmlFor="password">Create Password</label>
            <div className="passwordWrapper-reg">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleChange}
                required
                maxLength={15}
              />
              <button
                type="button"
                className="eyeIcon-reg"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {errors.password && (
              <span className="error validtext required">{errors.password}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm New Password</label>
            <div className="passwordWrapper-reg">
              <input
                id="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                maxLength={15}
              />
              <button
                type="button"
                className="eyeIcon-reg"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {errors.confirmPassword && (
              <span className={errors.confirmPassword === "Password Matched" ? "success-message" : "error-message"}>
                {errors.confirmPassword}
              </span>
            )}
            <p className="password-info">
              <span className="password-info-wrapper">
                <MdOutlineLock className="lock-icon" />
                Password must:
              </span>
              <ul>
                <li>
                  <TiTick className={`tick-icon ${passwordStrength.length ? "valid" : ""}`} />
                  Be a minimum of 6 to 15 characters
                </li>
                <li>
                  <TiTick className={`tick-icon ${passwordStrength.lowercase ? "valid" : ""}`} />
                  Include at least one lowercase letter (a-z)
                </li>
                <li>
                  <TiTick className={`tick-icon ${passwordStrength.uppercase ? "valid" : ""}`} />
                  Include at least one uppercase letter (A-Z)
                </li>
                <li>
                  <TiTick className={`tick-icon ${passwordStrength.number ? "valid" : ""}`} />
                  Include at least one number (0-9)
                </li>
              </ul>
            </p>
          </div>
        </div>
        <div className="form-actions">
          <button type="submit">REGISTER</button>
          <button type="button" className="cancel-btn" onClick={() => navigate("/")}>CANCEL</button>
        </div>
      </form>

      {showRegisterModal && (
        <RegisterModal
          isOpen={showRegisterModal}
          onClose={() => {
            setShowRegisterModal(false);
            navigate("/");
          }}
          email={formData.email}
          userType={userType}

        />
      )}
    </div>
  );
};

export default Registration;